import { render, staticRenderFns } from "./ClientViewProject.vue?vue&type=template&id=226006e4&"
import script from "./ClientViewProject.vue?vue&type=script&lang=js&"
export * from "./ClientViewProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226006e4')) {
      api.createRecord('226006e4', component.options)
    } else {
      api.reload('226006e4', component.options)
    }
    module.hot.accept("./ClientViewProject.vue?vue&type=template&id=226006e4&", function () {
      api.rerender('226006e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ClientViewProject.vue"
export default component.exports